module.exports = __webpack_public_path__ + "static/media/web-survey-logo.1af6836e.svg";